import { IconQuestionMarkOutline } from '@iwoca/icons';
import { Accordion } from '@iwoca/orion';

export const FAQContentDE = ({
    trackFaqClicked,
    loanDuration
}: {
    trackFaqClicked: (faqTitle: string) => void;
    loanDuration: number;
}) => {
    return (
        <div className="col-span-1 grid gap-s">
            {loanDuration >= 12 && (
                <Accordion
                    frame
                    icon={<IconQuestionMarkOutline />}
                    title="Kann ich eine Kreditaufstockung beantragen?"
                    small
                    data-testid="can-i-request-more-funds"
                    onClick={() =>
                        trackFaqClicked(
                            'Kann ich eine Kreditaufstockung beantragen?'
                        )
                    }
                >
                    <p className="m-0">
                        Sie können eine Kreditaufstockung anfragen,
                        <strong>
                            &nbsp;wenn Sie weniger als 70% Ihres Kreditsrahmens
                            in Anspruch nehmen.{' '}
                        </strong>
                        In Ihrem Kundenprofil sehen Sie, ob eine Aufstockung
                        möglich ist. Ist Ihre Anfrage erfolgreich, beginnt
                        wieder eine neue Laufzeit für die gesamte Kredithöhe.
                        <br />
                        <br />
                        Die Anfrage sowie die Bearbeitung sind für Sie
                        <strong>&nbsp;kostenlos und unverbindlich.</strong> Wenn
                        wir Ihnen einen Kredit anbieten, haben Sie einige Tage
                        Zeit zu entscheiden, ob Sie den Kredit ganz oder auch
                        nur teilweise aufnehmen.
                        <br />
                        <br />
                        Wir vergeben Kredite von 1.000 € bis 500.000 €.
                    </p>
                    <br />
                </Accordion>
            )}
            <Accordion
                frame
                icon={<IconQuestionMarkOutline />}
                title="Bis wann muss ich zurückzahlen?"
                small
                data-testid="how-do-early-repayments-work"
                onClick={() =>
                    trackFaqClicked('Bis wann muss ich zurückzahlen?')
                }
            >
                <p>
                    Wir bieten Kredite mit einer Laufzeit von bis zu 60 Monaten
                    an. Jeden Monat zahlen Sie einen Teil des Kredits und
                    anfallende Zinsen zurück. Details zur Laufzeit Ihres
                    aktuellen iwoca Kredits finden Sie in Ihrem
                    Rückzahlungsplan.
                    <br />
                    <br />
                    Den Flexi-Kredit können Sie jedoch
                    <strong>
                        &nbsp;jederzeit Ihrer Finanzlage anpassen:
                    </strong>{' '}
                    Haben Sie überschüssiges Geld? Zahlen Sie einfach mehr
                    zurück, um Zinsen zu sparen.
                </p>
                <br />
            </Accordion>
        </div>
    );
};
